export interface LevelUpAuthorizeParameters {
    system: string;
}

export interface LevelUpAuthResponse {
    id: string;
    url: string;
}

export interface LevelUpTokenGrantParameters {
    id: string;
    loopSeconds: string;
}

export interface LevelUpTokenGrantResponse {
    id: string;
    status: string;
    sbidStatus: string;
    expiresAt: string;
    code: number;
    customMessage: string;
    error: string;
    error_description: string;
    subcode: string;
}
